// extracted by mini-css-extract-plugin
export default {"container":"UsingNoviopus_container__NKwzu","content":"UsingNoviopus_content__a3-Ni"};